module.exports = __webpack_public_path__ + "img/feamp_logo.5762c140.webp";